LoginSigninController.$inject = [
    '$scope',
    'CONST',
    'Club',
    'User',
    '_',
    '$state',
    'Backoffice',
    'SessionSync',
];

/* @ngInject */
function LoginSigninController(
    $scope,
    CONST,
    Club,
    User,
    _,
    $state,
    Backoffice,
    SessionSync,
) {
    var vm = this;
    vm.title = 'LoginController';

    vm.clubName = Club.name;

    // Login form
    vm.email = '';
    vm.password = '';
    vm.remember = !!$scope.app.isMobile;

    vm.login = login;
    vm.error = null;
    vm.loading = true;

    // Avatar remembered
    vm.avatars = {
        selected: null,
        selectedName: null,
        remembered: [],
        select: function (avatar) {
            vm.avatars.selected = avatar.id;
            vm.avatars.selectedName = avatar.name;
            vm.email = avatar.email;
            vm.password = '';
        },
        unselect: function () {
            vm.avatars.selected = null;
            vm.avatars.selectedName = null;
            vm.email = '';
            vm.password = '';
        },
        forget: function (avatar) {
            SessionsController.forgetOne(avatar.id);
            vm.avatars.remembered = _.filter(
                vm.avatars.remembered,
                function (item) {
                    return item.id !== avatar.id;
                },
            );
            vm.avatars.unselect();
            if (SessionsController.getLast() === avatar.id) {
                SessionsController.setLast();
            }
        },
    };

    activate();

    // Clean up the service when the scope is destroyed
    $scope.$on('$destroy', function () {
        SessionSync.destroy();
    });

    ////////////////

    function activate() {
        // Initialize session sync service for login page
        SessionSync.init();

        var avatars = SessionsController.getAll(),
            selectedId = SessionsController.getLast(),
            selectedAvatar = selectedId ? avatars[selectedId] : null;

        if (selectedAvatar) {
            vm.avatars.select(selectedAvatar);
        }
        vm.avatars.remembered = _.map(avatars, function (data) {
            return new Avatar(data);
        });

        vm.loading = false;
    }

    function Avatar(data) {
        return {
            name: data.name,
            email: data.email,
            id: data.id,
            img: data.avatar
                ? '/uploads/avatars/' + data.avatar
                : '/uploads/avatars/no-avatar.png',
        };
    }

    function login() {
        vm.loading = true;
        vm.error = null;
        Backoffice.api
            .login({
                username: vm.email,
                password: vm.password,
            })
            .then(function () {
                return User.API.customPOST(
                    {
                        email: vm.email,
                        password: vm.password,
                        remember: !!vm.remember,
                    },
                    'login',
                    {
                        sportclub: Club.id,
                    },
                );
            })
            .then(function (user) {
                user = user.plain();
                SessionsController.set(user).setLast(user.id);
                User.install(user);

                // Notify other tabs about the login
                SessionSync.broadcastLogin(user.id);

                return CONST.$info({
                    only_club: true,
                });
            })
            .then(() => {
                const hasFeatureEnabled = Club.hasNewBookingsCalendarEnabled();
                if (hasFeatureEnabled) {
                    // Do something if the feature is enabled
                    $state.go('app.grid');
                    return;
                }
                $state.go('app.bookings');
            })
            .catch(function (e) {
                if (e.data && e.data.error && e.data.error.message) {
                    var errors = e.data.error.message;
                    vm.error = angular.isArray(errors)
                        ? errors.join('; ')
                        : errors;
                } else {
                    vm.error = 'Las credenciales introducidas son incorrectas.';
                }
                vm.loading = false;
                $scope.$apply();
            });
    }
}

var SessionsController = {
    ls: localStorage,
    /**
     * Saves/Updates an user into the localStorage
     * @method set
     * @param  {User} user
     * @chainable
     */
    set: function (user) {
        var users = this.getAll();
        users[user.id] = user;
        this.save(users);

        return this;
    },
    /**
     * Retrieves a user
     * @method get
     * @param  {Number} id
     * @return {User}
     */
    get: function (id) {
        return this.getAll()[id];
    },
    /**
     * Clears the saved users
     * @method forget
     * @chainable
     */
    forget: function () {
        return this.save({});
    },
    /**
     * Forgets one user
     * @method forgetOne
     * @param  {Number} id
     * @chainable
     */
    forgetOne: function (id) {
        var users = this.getAll();
        delete users[id];
        this.save(users);
        return this;
    },
    /**
     * Returns all the users
     * @method getAll
     * @return {Object}
     */
    getAll: function () {
        return JSON.parse(this.ls.getItem('session_users')) || {};
    },
    /**
     * Saves a single user
     * @method save
     * @param  {User} users
     * @chainable
     */
    save: function (users) {
        this.ls.setItem('session_users', JSON.stringify(users));
        return this;
    },
    /**
     * Remembers the last logged user
     * @method setLast
     * @param  {Number} id [description]
     * @chainable
     */
    setLast: function (id) {
        this.ls.setItem('session_last', id);
        return this;
    },

    /**
     * Gets the last logged user
     * @method getLast
     * @return {Number}
     */
    getLast: function () {
        return this.ls.getItem('session_last');
    },
};

export default LoginSigninController;
